import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import Icon from 'components/Icon'
import LastUpdatedDate from 'components/LastUpdatedDate'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import useGetMaxHeight from 'hooks/useGetMaxHeight'
import useSticky from 'hooks/useSticky'

import ClickToCall from './components/ClickToCall'
import CollapsibleContent from './components/CollapsibleContent'
import FeaturesContent from './components/FeaturesContent'

import classes from './CategoryInfoCard.module.scss'

const CategoryInfoCard = ({ category, facets, hasClickToCall = false, expandFeaturesContent = false }) => {
  const [ref, isSticky] = useSticky(0)
  const { isCypressTakingSnapshots } = useAppContext()

  const activeFeatureFacet = {
    ...(facets?.feature_tags_facet && Object.values(facets?.feature_tags_facet).find(filter => filter.selected)),
  }
  const hasFeaturesDrawer = !!activeFeatureFacet?.value && category?.key_features?.length > 0
  const hasDefinition = !!category.definition

  const height = useGetMaxHeight('[class*=CategoryInfoContainer]', { extraMargin: 0 })

  return (
    <>
      <div
        ref={ref}
        className={clsx('CategoryInfoCard', {
          [classes.sticky]: !isCypressTakingSnapshots,
          [classes.nonInteractive]: isSticky,
        })}
        style={{ height }}
      >
        <div className={clsx('CategoryInfoContainer', classes.background)}>
          <Container
            className={clsx(classes.root, {
              [classes.isSticky]: isSticky,
            })}
          >
            <div className={classes.categoryInfo}>
              <Icon icon={['ga', 'category']} className={classes.iconContainer} size="auto" />
              <div className={clsx(classes.textContainer, { [classes.hasClickToCall]: hasClickToCall })}>
                <Typography className={classes.categoryName} variant="heading-medium" component="h1">
                  {category.name}
                </Typography>
                {!isSticky && (
                  <>
                    {hasDefinition && (
                      <Typography
                        variant="body-xs"
                        className={clsx({ [classes.marginBottom]: !category.last_updated_on })}
                      >
                        {category.definition}
                      </Typography>
                    )}

                    {category.last_updated_on && <LastUpdatedDate lastUpdatedDate={category.last_updated_on} />}
                  </>
                )}
              </div>
            </div>
            {hasClickToCall && <ClickToCall className={clsx(classes.clickToCall, { [classes.isSticked]: isSticky })} />}
          </Container>
        </div>
      </div>
      <Container>
        <div className={classes.divider} />

        {hasFeaturesDrawer && (
          <div className={classes.extraContent}>
            <CollapsibleContent showText={false} expanded={expandFeaturesContent}>
              <FeaturesContent categoryName={category.name} keyFeatures={category.key_features} />
            </CollapsibleContent>
          </div>
        )}
      </Container>
    </>
  )
}

export default CategoryInfoCard
